import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sas-clinic.constants';

@Component({
  selector: 'app-sas-clinic-change-password-sent',
  templateUrl: './sas-clinic-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-clinic-change-password-sent.component.css',
  ],
})
export class SasClinicChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
